module.exports = __webpack_public_path__ + "media/images/icons/SVG/007-6f2dcba8b2b17186c01b6674e81043db.svg";